// extracted by mini-css-extract-plugin
export default {"item":"person_item__b8CzO","avatar":"person_avatar__W0vlQ","name":"person_name__YLVEj","login":"person_login__5h8jU","info":"person_info__gMlg4","btns":"person_btns__ee3nw"};